import { axiosInstance } from "./config";


const API = "/service-form";

export const getAllForm = async () => {
  const res = await axiosInstance.get(API);
  return res.data;
};